export function findBestMatch(district_str, shipDisData, ward_str='') {
    const normalizedInput = normalizeText(district_str);
    const normalizedWard = normalizeText(ward_str);
    const shipDisData_ = JSON.parse(JSON.stringify(shipDisData));
    const only_main_districts = Object.fromEntries(
                                    Object.entries(shipDisData_).filter(
                                        ([_, v]) => v.sub_districts === false
                                    ));     
    const only_sub_districts = Object.fromEntries(
                                    Object.entries(shipDisData_).filter(
                                        ([_, v]) => v.sub_districts === true
                                    )
                                );
                            

                                    
    for (const key in only_sub_districts) {
        const subDistrictInfo = only_sub_districts[key];
        const shipDis_group = subDistrictInfo.shipDis_group;
        try {
            only_main_districts[shipDis_group].has_sub_ward = true;
        } catch (error) {
            console.error('Error setting has_sub_ward:', error);
        }
    }

    let bestMatch = {
        shipDis: null
    };
    let bestScore = 0;

    for (const key in only_main_districts) {
        
        const districtInfo = only_main_districts[key];
        const parts = districtInfo.mapDistrict.split(',').map(p => normalizeText(p.trim()));

        for (const part of parts) {
            
        const score = similarity(normalizedInput, part);
        
        if (score > bestScore) {
            bestScore = score;
            bestMatch = districtInfo;
        }
        }
    }

    // Check for sub-ward match ????????????????????
    
    if (bestMatch && bestMatch.has_sub_ward) {
        const sub_districts_with_the_same_group = Object.fromEntries(
                                    Object.entries(only_sub_districts).filter(
                                        ([_, v]) => v.shipDis_group === bestMatch.shipDis_group
                                    )
                                );
                                
        for (const key in sub_districts_with_the_same_group) {
            const subDistrictInfo = sub_districts_with_the_same_group[key];
            const parts = subDistrictInfo.ward_list.split(',').map(p => normalizeText(p.trim()));

            for (const part of parts) {
                const score = similarity(normalizedWard, part);
                if (normalizedWard === part) {
                    bestMatch = subDistrictInfo;
                }
            }
        }

    }
    
    return bestMatch;
}

function normalizeText(text) {
  return text
    .toLowerCase()  
    .normalize('NFD')                   // Decompose accents
    .replace(/[\u0300-\u036f]/g, '')   // Strip accents
    .replace('đ', 'd')             // Normalize Vietnamese 'đ'
    .trim();
}

// Very basic scoring: 1 = perfect match, 0.9 = partial
function similarity(input, target) {
  if (target === input) return 0.99
  if (target.includes(input)) return 0.9;
  return 0;
}

export function splitKhong(text) {
  return text
    .replaceAll('không','Không')
    .trim()                                // 2) trim ends
    .split(/\s*,\s*|\s+(?=không)/i)         // 3) split on commas OR before “không”
    .map(s => s.trim())                    // 4) tidy each chunk
    .filter(Boolean);                      // 5) drop empties
}
